import {SvgProps} from "./SvgProps";

export default function SvgConsole(props: SvgProps){
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} className={props.className} viewBox="0 0 24 24" fill="none"
             stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="4" width="20" height="16" rx="2" ry="2"></rect>
            <path d="M8 9l3 3-3 3"></path>
            <line x1="14" y1="15" x2="18" y2="15"></line>
        </svg>
    )
}